import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { abreviateName, formatHumanTime, getBadgeColor } from 'src/app/shared/utils';
import { Dio, DIOCancelamento, DIOPrecificacao, DioDetalhesExecucao, DioEventos } from '../dio.model';
import { isEmpty } from 'lodash-es';
import { AuthService } from 'src/app/core';

@Component({
    selector: 'print-dio',
    templateUrl: './print-dio.component.html',
    styleUrls: ['./print-dio.component.css'],
    standalone: false
})
export class PrintDioComponent implements OnChanges {

    @Input() dio: Dio;
    @Input() apontamentos: any[] = [];
    @Input() observacoes: any[] = [];
    @Input() eventos: DioEventos[] = [];
    @Input() precificacoes: DIOPrecificacao[] = [];
    @Input() imagens: any[] = [];
    @Input() cancelamentos: DIOCancelamento[] = [];
    @Input() execucaoGPS?: DioDetalhesExecucao;
    @Input() showTarifacoes = false;
    @Input() showUsoEquipamento = false;
    @Input() showPrecificacoes = false;
    @Input() showApontamentos = false;
    @Input() showObservacoes = false;
    @Input() showMapa = false;
    @Input() showAfericao = false;
    @Input() showVerAfericao = false;

    now = new Date();
    getBadgeColor = getBadgeColor;
    formatHumanTime = formatHumanTime;
    abreviateName = abreviateName;

    constructor(public authService: AuthService) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dio'] && changes['dio'].currentValue) {
            this.populateNullValues(this.dio);
        }
    }

    populateNullValues(obj: any) {
        for (var key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                this.populateNullValues(obj[key]);
            } else if (obj[key] == null) {
                obj[key] = '';
            }
        }
    }

    hasDio() {
        return !isEmpty(this.dio);
    }

    isMaquina() {
        return this.dio?.alocacao?.equipamento?.grupo?.tarifacoes === 'MAQUINAS';
    }

    isVeiculo() {
        return this.dio?.alocacao?.equipamento?.grupo?.tarifacoes === 'VEICULOS';
    }

}
